import React, { Children } from "react";

const FilterOptions = ({ filters, setFilters, handleOpenModal, isDispatching = false, children }) => {
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    return (
        <div className="flex gap-4 items-center bg-gray-100 p-4 rounded-md w-full">
            {/* Status Filter */}
            <div className="flex-2">
                <label className="block text-sm font-medium">Status</label>
                <select
                    name="status"
                    value={filters.status}
                    onChange={handleChange}
                    className="border p-2 rounded w-full"
                >
                    <option value="">All</option>
                    <option value="Active">Active</option>
                    <option value="Dispatch">Dispatch</option>
                    <option value="Completed">Completed</option>
                </select>
            </div>

            {/* Priority Filter */}
            <div className="flex-2">
                <label className="block text-sm font-medium">Priority</label>
                <select
                    name="priority"
                    value={filters.priority}
                    onChange={handleChange}
                    className="border p-2 rounded w-full"
                >
                    <option value="">All</option>
                    <option value="1">1 (Low)</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5 (High)</option>
                </select>
            </div>

            {isDispatching ? (
                <div className="flex-1">
                    {children}
                </div>
            ) : (
                <div className="flex-1">
                    <button onClick={handleOpenModal} className="bg-blue-500 text-white px-4 py-2 rounded-md mt-4">
                        + Add New Call Log
                    </button>
                </div>
            )}
        </div>
    );
};

export default FilterOptions;